import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";

export class HorseItem extends SceneDraggable {
    cancelSelectionWhenAnotherDragStarts = true;

    public drop() {
        super.drop();
        this.dragEnd();
    }
}
